import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'
import { InnerWrapper } from './Common'

const Image = styled.img`
  width: 100%;
  height: 86px;
  padding-top: 9px;

  @media ${device.mobileM} {
    height: 140px;
    padding-top: 12px;
  }

  @media ${device.tablet} {
  ${''/* height: 210px; */}
    height: 10.9375vw;
  ${''/* padding-top: 20px; */}
    padding-top: 1.0416666666666667vw;
  }
`

const PackageName = styled.h3`
  font-family: 'BarlowSemiBold';
  text-transform: uppercase;
  color: #fff;
  padding-bottom: 8px;
  font-size: 18px;

  @media ${device.tablet} {
    ${''/* font-size: 22.5; */}
    font-size: 1.1458333333333335vw;
    padding-bottom: 0.4166666666666667vw;
  }
`

const Price = styled.h2`
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  color: #fff;
  padding-bottom: 8px;
  font-size: 22px;

  @media ${device.tablet} {
  ${'' /* font-size: 33.75; */}
    font-size: 1.71875vw;
    padding-bottom: 0.4166666666666667vw;
  }
`

const Text = styled.p`
  font-family: 'BarlowSemiBold';
  color: #fff;
  font-size: 14px;

  @media ${device.tablet} {
    font-size: 10px;
  }

  @media ${device.laptop} {
    font-size: 11px;
  }

  @media ${device.laptopM} {
    font-size: 12px;
  }

  @media ${device.laptopL} {
    font-size: 15px;
  }

  @media ${device.desktop} {
    font-size: 16px;
  }
`

const FooterText = styled.p`
  font-family: 'BarlowSemiBold';
  color: #4d4d4d;
  padding-bottom: 4px;
  font-size: 14px;

  @media ${device.tablet} {
  ${'' /* font-size: 19.6; */}
    font-size: 0.9895833333333334vw;
  }
`

const CardHeader = styled.div`
  height: 80px;
  display: flex;
  flex-direction: column;
  background: #999999;
  justify-content: center;
  width: 100%;
  background-color: ${props => props.selected ? props.theme.color.hoverPrimary : 'none'};

  @media ${device.tablet} {
  ${''/* height: 126px; */}
    height: 6.5625vw;
  }

  ${'' /* @media ${device.laptopM} {
    height: 90px;
  }

  @media ${device.laptopM} {
    height: 95px;
  }

  @media ${device.laptopL} {
    height: 110px;
  }

  @media (min-width: 1770px) {
    height: 136px;
  } */}
`

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
  justify-content: space-between;
  text-align: center;
  cursor: pointer;
  border: 5px solid ${props => props.selected ? props.theme.color.hoverPrimary : 'transparent'};
  outline: none;
  margin: 10px 0;

  @media ${device.mobileM} {
    width: 240px;
  }

  @media ${device.tablet} {
    ${''/* width: 200px; */}
    width: 20.104166666666668vw;
  }

  ${'' /* @media ${device.laptop} {
    width: 200px;
  }

  @media ${device.laptopM} {
    width: 235px;
  }

  @media ${device.laptopL} {
    width: 305px;
  }

  @media (min-width: 1770px) {
    width: 407px;
  } */}

  &:hover {
    border: 5px solid ${props => props.theme.color.hoverPrimary};
  }

  &:hover ${CardHeader} {
    background-color: ${props => props.theme.color.hoverPrimary};
  }
`

const CardFooter = styled.div`
  background-color: #F3F3F3;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 24px;
  padding-bottom: 26px;
  height: 70px;

  @media ${device.tablet} {
    ${'' /* padding-top: 24px;
    padding-bottom: 27px;
    height: 60px; */}
    padding-top: 1.25vw;
    padding-bottom: 1.40625vw;
    height: 3.125vw;
  }
`

const PackageCard = ({ name, price, footerText, description, image, to, selected, ...props }) => {
  return (
    <OuterWrapper selected={selected} {...props}>
      <CardHeader selected={selected}>
        <PackageName>{name}</PackageName>
        <Price>{price}</Price>
        <Text>a partire da</Text>
      </CardHeader>
      <InnerWrapper>
        <Image src={image} />
      </InnerWrapper>
      <CardFooter>
        {footerText.map((text, index) => <FooterText>{index > 0 && '+ '}{text}</FooterText>)}
      </CardFooter>
    </OuterWrapper>
  )
}

PackageCard.propTypes = {
  /**
   * Price of the Package
   */
  price: PropTypes.string,

  /**
   * Text at the bottom of the Card
   */
  footerText: PropTypes.array,

  /**
   * Description of the Card
   */
  description: PropTypes.string,

  /**
   * Image of the Card
   */
  image: PropTypes.string.isRequired
}

export default PackageCard



// WEBPACK FOOTER //
// ./src/components/Calculator/Card/PackageCard.js